/**
 * Le `meta` des mutations, typé pour tout le dépôt.
 *
 * `handlesApiFailure` : l'écran affiche LUI-MÊME le refus de cette mutation
 * (`ApiFailureAlert`, `useApiFailureSnackbar`, message dans le formulaire). Le filet
 * global du `QueryClient` (cf. `createQueryClient`) se tait alors, pour ne pas montrer le
 * même refus deux fois. Sans ce drapeau, tout refus d'une mutation s'affiche en snackbar.
 */
export interface AppMutationMeta extends Record<string, unknown> {
  handlesApiFailure?: boolean;
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: AppMutationMeta;
  }
}

/**
 * Ce qu'un hook de mutation accepte de son appelant. Un même hook sert des écrans qui
 * affichent son refus et d'autres qui ne le font pas : c'est donc l'appelant qui dit
 * s'il s'en charge, pas le hook.
 */
export interface MutationUiOptions {
  meta?: AppMutationMeta;
}

/** Raccourci pour un appelant qui affiche lui-même le refus. */
export const HANDLES_API_FAILURE: MutationUiOptions = {meta: {handlesApiFailure: true}};
